import React from 'react';
import { FacebookProvider, Login } from 'react-facebook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons';
import makeCancelable from '../helpers/PromiseWrapper';
import { getCsrfToken, handleCsrfFailure } from '../helpers/GetCsrfToken';

export default class FacebookLogin extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: false
    };
    this.requests = [];
  }
  componentWillUnmount() {
    for (let i = 0; i < this.requests.length; i++) {
      this.requests[i].cancel();
    }
  }
  handleResponse = data => {
    this.setState({ loading: true });
    let request = makeCancelable(fetch('api/Customer/SocialLogin', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken()
      },
      body: JSON.stringify({
        provider: 'facebook',
        accessToken: data.tokenDetail.accessToken,
        userId: data.tokenDetail.userID,
        emailAddress: data.profile.email
      })
    }));
    this.requests.push(request);
    request.then(response => {
        if (response.status === 200) {
          response.json().then(responseData => {
            if (
              !!responseData.customerSessionToken &&
              responseData.customerSessionToken.pizzaExpressId > 0
            ) {
              this.setState({
                loading: false
              });
              this.props.handleLogin(responseData);
            } else {
              this.setState({
                loading: false
              });
              var profile = {
                firstName: data.profile.first_name,
                lastName: data.profile.last_name,
                emailAddress: data.profile.email
              };
              this.props.goToRegister(profile);
            }
          });
        } else if (response.status === 400) {
            handleCsrfFailure();
        }
      })
      .catch(error => {
        this.setState({
          loading: false
        });
        console.log(error);
      });
  };

  handleError = error => {
    console.log(error);
    this.setState({loading: false})
  };

  render() {
    const elementFacebook = <FontAwesomeIcon icon={faFacebookSquare} />;
    const mainText = this.state.loading === true ? 'Logging in...' : 'Log in with Facebook';
    return (
      <FacebookProvider appId="2045384485674955">
        <Login
          scope="email"
          onCompleted={this.handleResponse}
          onError={this.handleError}
        >
          {({ loading, handleClick, error, data }) => (
            <button
              className="btn btn-primary social-login facebook"
              onClick={handleClick}
            >
              {elementFacebook} {mainText}
            </button>
          )}
        </Login>
      </FacebookProvider>
    );
  }
}
